import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import * as SignatureManagerActions from 'SignatureManager/SignatureManagerActions';
import { createSigPopup, createSignatureEvent } from 'actions';
import withInit from 'WithInit';

const withSignatures = (WrappedComponent) => {
  const mapStateToProps = ({ SignatureHandler }) => ({
    imageUrls: SignatureHandler.imageUrls,
    lastUsedImageType: SignatureHandler.lastUsedImageType,
    lastUsedImageUrl: SignatureHandler.lastUsedImageUrl,
  });

  const mapDispatchToProps = dispatch => (
    bindActionCreators({
      ...SignatureManagerActions,
      createSigPopup,
      createSignatureEvent,
    }, dispatch)
  );

  const ConnectedSignatureComponent = ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps,
  )(WrappedComponent);

  const SignatureContainerWithInit = withInit(ConnectedSignatureComponent, true);

  return SignatureContainerWithInit;
};

export default withSignatures;



// WEBPACK FOOTER //
// ./src-react/SignatureManager/EnhanceSignatures.jsx